import { Link } from "react-router-dom";

// Shared by the blog overview and the related posts on single posts.

export const OVERVIEW_PATH = "/community";
const MAX_CARD_CATEGORIES = 3;

// Same URL shape as the old SilverStripe blog; routed in src/index.js.
export const categoryPath = (slug) => `${OVERVIEW_PATH}/category/${slug}`;

// Posts store categories as datasource slugs; the display names live in the
// blog-categories datasource.
export const fetchCategoryNames = (storyblokApi) =>
  storyblokApi
    .get("cdn/datasource_entries", { datasource: "blog-categories", per_page: 1000 })
    .then(({ data }) => new Map(data.datasource_entries.map((e) => [e.value, e.name])))
    .catch(() => new Map());

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const categoryName = (slug, categoryNames) =>
  capitalize(categoryNames.get(slug) || slug.replace(/-/g, " "));

// Summary comes from SilverStripe's Summary HTMLText field and may contain
// raw markup and entities (&nbsp; etc.) — strip to plain text for the card
// preview by parsing it as HTML rather than regexing tags, so entities
// decode correctly too.
const SUMMARY_PREVIEW_LENGTH = 200;

const stripHtml = (html) => {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  return (div.textContent || "").replace(/\s+/g, " ").trim();
};

const truncate = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trimEnd()}…`;
};

// Ask Storyblok's image service for a card-width resize (height 0 keeps the
// original aspect ratio, so nothing is cropped) instead of the full upload.
const cardImageSrc = (filename) =>
  filename.includes("a.storyblok.com") ? `${filename}/m/840x0/filters:quality(80)` : filename;

export const ArticleList = ({ articles, categoryNames }) => {
  return articles.map((article) => {
    const image = article.content.featured_image?.filename;
    const categories = [...new Set(article.content.categories || [])].slice(0, MAX_CARD_CATEGORIES);

    return (
      <li key={article.uuid} className="blog-card">
        <div className="blog-card-image">
          {image ? <img src={cardImageSrc(image)} alt="" loading="lazy" /> : null}
        </div>
        {categories.length ? (
          <ul className="blog-card-tags">
            {categories.map((slug) => (
              <li key={slug}>
                <Link to={categoryPath(slug)}>{categoryName(slug, categoryNames)}</Link>
              </li>
            ))}
          </ul>
        ) : null}
        <h2 className="blog-card-title">
          {/* Stretched over the whole card via ::after so the card is one link. */}
          <Link to={`/${article.full_slug}`}>{article.name}</Link>
        </h2>
        <p className="blog-card-summary">
          {truncate(stripHtml(article.content.summary), SUMMARY_PREVIEW_LENGTH)}
        </p>
      </li>
    );
  });
};
